module.exports = __webpack_public_path__ + "static/media/Page20.f52d8e77.png";